import { ErrorModel } from '@shared/models/app-state.model';

export function parseCustomErrorMessage(error: ErrorModel): string | null {
  if (error.error?.message == null) return null;
  return error.error.message.replace('Unauthenticated: ', '');
}
